import React,{useEffect,useState} from 'react';
import SuccessionPlanItem from "../../../Items/SuccessionPlanItem";

import { postData } from '../../../../services/api';
import { useTranslation } from "react-i18next";


const SuccessPlanSection = () => {
  const { i18n,t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [sortKey, setSortKey] = useState("created_at");
  const [sortValue, setSortValue] = useState(-1);
  const [sortQuery, setSortQuery] = useState("");
  const [planData, setPlanData] = useState([]);

  useEffect(() => {
    if (sortKey && sortValue) {
      setSortQuery({ [sortKey]: sortValue });
    } else {
      setSortQuery("");
    }
  }, [sortKey, sortValue]);

  useEffect(() => {
    const loadList = async () => {
      setLoading(true);
      const result = await postData("/successionplan/list", {
        sortQuery: sortQuery
      });
      if (result.data) {
        setPlanData(
          result.data.map((item,index)=>{
            return {
              icon: "fa-solid fa-circle-check",
              title : item?.name?.[i18n?.language],
              description : '<p>'+item?.description?.[i18n?.language]+'</p>'
            }
          })
        );
        setLoading(false);
      }
    };
    loadList();
  }, []);


  const SuccessionPlanData = {
    title:t('a_better_way_to_succession_plan'),
    SuccessionPlan: planData
    // [
    //   {
    //     icon:"fa-solid fa-circle-check",
    //     title:"No Technical Skills Required",
    //     description:"<p>A step-by-step guide makes making a succession plan a breeze. </p>",
    //   },
    //   {
    //     icon:"fa-solid fa-circle-check",
    //     title:"Save Hours of Time",
    //     description:"<p>Succession plans can be made in less than 30 minutes.</p>",
    //   },
    //   {
    //     icon:"fa-solid fa-circle-check",
    //     title:"Quantifiable Results",
    //     description:"<p>Auto-generated reports gives a quantifiable comparison of the candidates being considered. </p>",
    //   }
    // ]
  }
  return (
    <section className="relative w-full py-10 lg:py-14 xl:py-16 2xl:py-20 bg-dark-teal-800" id="successplan-section">
      <div className="w-full px-4  lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl  mx-auto">
        <div className="w-full mx-auto text-center mb-6 lg:mb-12">
            <h2 className="capitalize text-white text-2xl xs:text-3xl lg:text-4xl xl:text-5xl font-extrabold font-PlusJakartaSans" dangerouslySetInnerHTML={{__html:SuccessionPlanData.title}}></h2>
        
        </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 xl:gap-8">
                  {SuccessionPlanData.SuccessionPlan.map((item, index) => (
                      <SuccessionPlanItem key={index} data={item}/>
                  ))}
          </div>
      </div>
    </section>
  );
};

export default SuccessPlanSection;